import axios from 'axios';
// import serverAddress from '../config';
// import firebase from '../utils/firebase';
// import { Cookies } from 'react-cookie';

// const cookies = new Cookies();

const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_ADDRESS,
    timeout: 30000,
    // transformRequest: [function (data, headers) {
    //     // console.log("headers -- ", headers);
    //     firebase.auth().onAuthStateChanged(user => {
    //         if (user) {
    //             user.getIdToken()
    //                 .then(function(idToken) {
    //                     localStorage.setItem('accessToken', idToken);

    //                     headers.common['authorization'] = `Bearer ${idToken}`
    //                     headers.common['Content-Type'] = `application/json`
    //                 })
    //                 .catch(function(error) {
    //                     console.log(error);
    //                 });
    //         }
    //     });
    //     return data;
    //   }],
});

instance.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        // if (error.message == 'Network Error') {
       
        if (error?.response?.status === 403 || error?.response?.status === 401) {            
            window.location.href = `${process.env.REACT_APP_SESSION_EXP}`;
        }
        // }
        return Promise.reject(error);
    },
);

export { instance as default };
